import React  from "react";
import { useParams } from 'react-router-dom';
import FinalPayForm from "./components/FinalPayForm";

const ViewFinalPay = () => {
	const { payId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<FinalPayForm recordId={payId} mode="view"/>
	      </div>
	    </div>
    );
};

export default ViewFinalPay;